import { Component } from "modules/Component";

export class Breadcrumbs extends Component<typeof Breadcrumbs> {
    static readonly className: string = "js-breadcrumbs-component";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        const menuIcon = rootElement.querySelector<HTMLLIElement>("li.menu");
        const menuList = rootElement.querySelector<HTMLElement>(".menu__list");

        menuIcon?.addEventListener("click", () => {
            menuList?.classList.toggle("active");
        });
        
    }
}